module.exports = __webpack_public_path__ + "static/media/sf-landmark-5.b33e7c1f.png";